import { render, staticRenderFns } from "./TournamentBuilderTournament.vue?vue&type=template&id=205bed65&"
import script from "./TournamentBuilderTournament.vue?vue&type=script&lang=js&"
export * from "./TournamentBuilderTournament.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBuilderTournament.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout,VSelect,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('205bed65')) {
      api.createRecord('205bed65', component.options)
    } else {
      api.reload('205bed65', component.options)
    }
    module.hot.accept("./TournamentBuilderTournament.vue?vue&type=template&id=205bed65&", function () {
      api.rerender('205bed65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentBuilderTournament.vue"
export default component.exports